export default "__VITE_ASSET__34d73222__"